import type { APIResponse } from '@tabbio/types';

export class LibraryApiError extends Error {
  constructor(
    message: string,
    readonly code: string,
    readonly setupRequired = false,
  ) {
    super(message);
    this.name = 'LibraryApiError';
  }
}

export function getLibraryResponseError<T>(response: APIResponse<T>) {
  if (!response.error) {
    return null;
  }

  return new LibraryApiError(
    response.error.message,
    response.error.code,
    response.error.code === 'LIBRARY_NOT_READY' || Boolean(response.meta?.setupRequired),
  );
}

export function isLibrarySetupRequiredError(error: unknown): error is LibraryApiError {
  return error instanceof LibraryApiError && error.setupRequired;
}
